/* eslint-disable @typescript-eslint/explicit-function-return-type */
import COLORS from "constant/colors";
import { Tooltip, Box /*, Stack, IconButton */, Typography, Link } from "@mui/material";
// import MailOutlineIcon from "@mui/icons-material/MailOutline";
import { useTranslation } from "react-i18next";
import React from "react";

export const FooterComponent = () => {
  const { t } = useTranslation("translation");
  const EMAIL_ADRESS = "contact@betaclic.com";
  /* const socialMediaItems = [
    {
      id: 1,
      iconName: "fa-instagram",
      url: "https://www.instagram.com/betaclic.mr",
      altText: "Instagram",
    },
    {
      id: 2,
      iconName: "fa-facebook",
      url: "https://www.facebook.com/BetaClic/",
      altText: "Facebook",
    },
    {
      id: 3,
      iconName: "fa-linkedin",
      url: "https://www.linkedin.com/company/betaclic/",
      altText: "Linkedin",
    },
  ];

  const onNavigate = (item) => {
    const url = String(item?.url ?? ""); // ensures a string
    window.open(url, "_blank", "noopener,noreferrer");
  }; */
  /* const onContact = () => {
     // const mail = String(email ?? "").trim();
 
     // Use window.location to open the user's mail client via mailto
     window.location.href = `mailto:${EMAIL_ADRESS}`;
   }; */
  return (
    <>
      <Box
        component="footer"
        sx={{
          // position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
          bgcolor: COLORS.lightGreen,
          // height: "7vh",
          //  minHeight: "30px",
          // px: 1,
          py: 3,
          // justifyContent: "center",
          // alignItems: "center",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
        }}
      >
        {/* <Stack
          direction="row"
          spacing={1}
          justifyContent="center"
          alignItems="center"
          flexWrap="wrap"
          sx={{ mb: 1 }}
        >
          { socialMediaItems.map((i) => (
            <Tooltip key={i.id} title={i?.altText ?? ""} arrow>
              <IconButton
                aria-label={i?.altText ?? "réseaux sociaux"}
                onClick={() => {
                  onNavigate(i);
                }}
                size="small"
                sx={{ border: "1px solid rgba(0,0,0,0.1)", bgcolor: "transparent" }}
              >
                <i className={`fab ${i.iconName} fa-lg`} />
                <span className="visually-hidden">{i.altText ?? "réseaux sociaux"}</span>
              </IconButton>
            </Tooltip>
          )) }

        
          <Tooltip title="Contact" arrow>
            <IconButton
              aria-label="contact"
              onClick={() => {
                onContact();
              }}
              size="small"
              sx={{ border: "1px solid rgba(0,0,0,0.1)", bgcolor: "transparent" }}
            >
              <MailOutlineIcon fontSize="small" />
              <span className="visually-hidden">Contact</span>
            </IconButton>
          </Tooltip>
        </Stack> */}

        <Typography variant="h8" align="centers" sx={{ fontWeight: "normal", fontSize: "0.7rem" }}>
          <Tooltip title={t("visit_website")} arrow>
            <Link
              href="https://www.betaclic.com"
              target="_blank"
              rel="noopener noreferrer"
              underline="none"
              sx={{ color: COLORS.primary }}
            >
              BetaClic
            </Link>
          </Tooltip>
          {" | "}
          <Tooltip title={t("send_email")} arrow>
            <Link href={`mailto:${EMAIL_ADRESS}`} underline="none" sx={{ color: COLORS.primary }}>
              {EMAIL_ADRESS}
            </Link>
          </Tooltip>
          <br />
          &copy; {new Date().getFullYear()} | {t("copyright")} <br />
        </Typography>
      </Box>
    </>
  );
};
